import { render, staticRenderFns } from "./arviointityokalu-lomake-kysymys-form.vue?vue&type=template&id=111d70be&scoped=true&"
import script from "./arviointityokalu-lomake-kysymys-form.vue?vue&type=script&lang=ts&"
export * from "./arviointityokalu-lomake-kysymys-form.vue?vue&type=script&lang=ts&"
import style0 from "./arviointityokalu-lomake-kysymys-form.vue?vue&type=style&index=0&id=111d70be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111d70be",
  null
  
)

export default component.exports